import React, { useState, useEffect } from "react";
import "nouislider/distribute/nouislider.css";
import Nouislider from "nouislider-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  checkItem,
  getPrice,
  setShopFilter,
} from "../../../../Redux/Slices/ProductSlice";
import { checkFLMasterListing } from "../../../../Redux/Slices/FiltergetSlice";
const Price = ({
  data,
  values,
  setValues,
  selectshopFilter,
  setSelectshopFilter,
  ischecked,
  setIschecked,
  filterTitle,
}) => {
  let { filterSelection } = useSelector((state) => state.ProductSlice);
  const {checkedFilterCM} = useSelector((e)=> e.FiltergetSlice)
  console.log(checkedFilterCM.price,"checkedFilterCM")
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [percent, setPercent] = useState("299");
  // const [values, setValues] = useState([299, 105999]);
  console.log(values, "values");
  const minValue = data?.[0]?.minPrice
  const maxValue = data?.[0]?.maxPrice
  console.log(minValue,"minValue",maxValue,data?.[0]?.minPrice,data?.[0]?.maxPrice) 

  // const onChangeSlide = async (data) => {
  //   let value = data?.map(Number);
  //   value = [...new Set(value)];
  //   setValues([value[0], value[1]]);
  //   setSelectshopFilter((selectshopFilter) => [
  //     ...selectshopFilter,
  //     value[0],
  //     value[1],
  //   ]);
  //   dispatch(getPrice(value));
  // };

  // useEffect(() => {
  //   if (filterSelection?.price?.length === 0) {
  //     setValues([299, 105999]);
  //   }
  // }, [filterSelection?.price]);
  return (
    <div className="filter-box">
      <div className="filter-header">
        <div className="filter-title">{`${t("productlisting.price")}`}</div>
      </div>
      <div className="price-range">
        <Nouislider
          connect={true}
          range={{ min: minValue, max: maxValue }}
          behaviour="drag"
          step={100}
          start={values}
          tooltips={true}
          onEnd={(data) => {
            setValues([Number(data[0]),Number(data[1])])
            dispatch(
              checkFLMasterListing({
                mainId: {
                  uniqId: 1,
                  filterName: [Number(data[0]),Number(data[1])],
                },
                name: "price",
              })
            );
            console.log(data,"DATATTATA")
            // onChangeSlide(data);
          }}
        />

        {/* {percent && ( */}
        <div className="price-text">
          <span>{`${t("productlisting.price")}`} :</span> {checkedFilterCM.price?.filterName?.lenngth > 0 ? `₹ ${checkedFilterCM.price?.filterName?.[0]} - ₹ ${checkedFilterCM.price?.filterName?.[1]}`  : `₹ ${values[0]} - ₹ ${values[1]}`} 
          
          
          
{/*           
          ₹ {checkedFilterCM.price?.filterName?.[0]} - ₹
          {checkedFilterCM.price?.filterName?.[1]} */}
        </div>
        {/* )} */}
        {/* <p>
          <span>₹{values[0]}</span> -<span> ₹{values[1]}</span>
        </p> */}
      </div>
    </div>
  );
};

export default Price;
